export default __webpack_public_path__ + "static/la-petite-prince-collection-10dec5c50d8448cba50c1395180f8f6c.jpg";